"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const StateReducer = (state, action) => {
    // Replace whole state
    if (!action.payload) {
        return Object.assign(Object.assign({}, state), action);
    }
    const { stateName, type, data } = action.payload;
    switch (type) {
        default:
            return Object.assign(Object.assign({}, state), { [stateName]: data });
    }
};
exports.default = StateReducer;
